module.exports = __webpack_public_path__ + "img/tiramisu-1.e911002c.jpg";